// This file is a collection of all available mutations in the application.

// module praemien
export const SET_AVAILABILITY = "Setting availability";
export const SET_RAW_PRAEMIEN = "Setting Prämien raw data";
